export default __webpack_public_path__ + "static/media/franni-screenshots.91049549.jpg";